<usimweb-status-bar
  *ngIf="progress$ | async"
  style="top: 0px !important; height: 20px"
  [mode]="'indeterminate'"
></usimweb-status-bar>

<div class="space">
  <usimweb-button-icon [icon]="'arrow_back'" fontColor="white" (btnClick)="back()"></usimweb-button-icon>
</div>

<div class="dashboard">
  <div class="row mt-4">
    <div style="display: inline-block; width: 99%">
      <usimweb-version-filter
        (filter)="filter($any($event))"
        (toggleCompareChange)="toggleCompare($any($event))"
      ></usimweb-version-filter>
    </div>
  </div>

  <div class="row mt-4 {{ isCompare ? 'compare' : 'no-compare' }}">
    <div *ngIf="!isCompare" class="col-sm-6 col-lg-6 col-xl-3 mb-3">
      <usimweb-projectcard
        [newProject]="true"
        [newItemLink]="newVersionLink"
        [newCardTitle]="'New simulation'"
        (routeEvent)="route($event)"
        data-cy="new_simulation"
      ></usimweb-projectcard>
    </div>

    <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let version of (versions$ | async)!">
      <usimweb-projectcard
        #cardItem
        [cardItem]="version"
        [link]="versionLink"
        [compare]="isCompare"
        (selectedIndexEvent)="indexChanged($event)"
        (routeEvent)="route($event)"
        (dialogEvent)="openDialog($event)"
      ></usimweb-projectcard>
    </div>
  </div>
</div>
